module.exports = __webpack_public_path__ + "img/file-download.9c2af597.svg";